module.exports = __webpack_public_path__ + "static/media/iconCanvas05.36334c45.svg";